// src/app/login/page.tsx
'use client';

// Aquí importas el componente de la página de Login que ya creamos
import LoginPage from '../../sections/auth/LoginPage';

export default function LoginPages() {
  return <LoginPage />;
}